export default __webpack_public_path__ + "static/media/H1006.bb417888.mp3";